module["exports"] = [
  "com",
  "pl",
  "com.pl",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pl/internet/domain_suffix.js
 ** module id = 856
 ** module chunks = 0
 **/